module.exports = __webpack_public_path__ + "img/47.35c1b014.jpg";